<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{$t("placements")}}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">{{$t("management")}}</a></li>
              <li class="breadcrumb-item active">{{$t("placement_management")}}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-9">
          <div class="card">
            <div class="card-header pb-0">
              <h5 v-if="editMode">{{$t("edit_placement")}}</h5>
              <h5 v-else>{{$t("create_placement")}}</h5>
            </div>
            <LanguagePicker v-model="selectedLanguage" />
            <div class="card-body">
              <div class="form theme-form">
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("designation")}}*</label>
                      <input class="form-control" type="text" v-model="placement.names[selectedLanguage]">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>Eindeutige Bezeichnung (für Referenzierung zur App)*</label>
                      <input class="form-control" type="text" v-model="placement.uniqueName">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("type")}}*</label>
                      <v-select class="mt-0 pt-0" v-model="placement.type" :items="adtypes" append-icon="" hide-details>
                        <template slot="item" slot-scope="data">
                          {{ data.item }}
                        </template>
                        <template slot='selection' slot-scope="data">
                          {{ data.item }}
                        </template>
                      </v-select>
                      <!-- <input class="form-control" type="text" v-model="placement.type"> -->
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("cpm_price")}}*</label>
                      <input class="form-control" type="number" v-model="placement.cpmPrice">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{$t("cpc_price")}}*</label>
                      <input class="form-control" type="number" v-model="placement.cpcPrice">
                    </div>
                  </div>
                </div>
                <div class="row">
                   <div class="col">
                      <div class="mb-3">
                        <label>{{$t("estimated_views_per_user_per_day")}}*</label>
                        <input class="form-control" type="number" v-model="placement.viewsPerUserPerDay">
                      </div>
                    </div>
                    <div class="col">
                      <div class="mb-3">
                        <label>{{$t("estimated_clicks_per_impression")}}*</label>
                        <input class="form-control" type="number" v-model="placement.clicksPerImpression">
                      </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{$t("app")}}*</label>
                      <v-select class="mt-0 pt-0" v-model="placement.app" :items="apps" item-text="name" item-value="id"
                        append-icon="" hide-details>
                        <template slot="item" slot-scope="data">
                          <img style="width:40px;height: 40px;"  class="rounded-lg app-icon mr-5" :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                        </template>
                        <template class="py-2" slot='selection' slot-scope="data">
                          <img style="width:40px;height: 40px;"  class="rounded-lg app-icon my-1 mr-5" :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{$t("preview_image")}}*</label>
                      <Upload :label="''" v-model="placement.previewImage" />
                    </div>
                  </div>
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{$t("example_image")}}*</label>
                      <Upload :label="''" v-model="placement.exampleImage" />
                    </div>
                  </div>
                </div>
                <button style="float: right;" @click="save()" class="btn btn-primary" type="button"
                  data-bs-original-title="" title="">{{$t("save")}}</button>
                  <button class="btn btn-secondary mr-2" style="float: right;" @click="$routerBack()">{{$t("cancel")}}</button>
              </div>
            </div>
          </div>

        </div>
        <div class="col-3">
            <div class="card">
              <div class="card-header pb-0">
                <h5>{{$t("actions")}}</h5>
              </div>
              <div class="card-body" v-if="editMode">
                <button @click="showDeleteConfirmation = true" class="btn btn-danger" type="button"
                  data-bs-original-title="" title="">{{$t("delete_placement")}}</button>
              </div>
              <div class="card-body" v-else>
                <p>{{$t("PLACEMENT_SAVE_BEFORE_DELETE_HINT")}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Container-fluid Ends-->
      <div class="modal fade show" v-show="showDeleteConfirmation" tabindex="-1" aria-labelledby="exampleModalCenter" style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t("delete_placement")}}</h5>
            <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" data-bs-original-title="" title="" @click="(showDeleteConfirmation = false)"></button>
          </div>
          <div class="modal-body">
            <p>{{$t("confirm_delete_placement")}}</p>
          </div>
          <div class="modal-footer">
            <button @click="(showDeleteConfirmation = false)" class="btn btn-secondary" type="button" data-bs-dismiss="modal" data-bs-original-title="" title="">{{$t("cancel")}}</button>
            <button @click="deletePlacement()" class="btn btn-danger" type="button" data-bs-original-title="" title="">{{$t("delete")}}</button>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { MapPinIcon, PlusSquareIcon } from 'vue-feather-icons'

export default {

  props: {
    placementId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
  },
  data() {
    return {
      editMode: false,

      routes: {
        placements: "/api/placement",
        apps: "/api/app",
        filter: "/api/tenants/search/"
      },

      placement: {
        app: "",
        type: "",
        names: {},
        uniqueName: "",
        previewImage: "",
        exampleImage: "",
        cpcPrice: 0,
        cpmPrice: 0,
        viewsPerUserPerDay: 0,
        clicksPerImpression: 0
      },

      selectedLanguage: "en",

      showDeleteConfirmation:false,

      adtypes: ["BANNER",
        "RECTANGLE_BANNER",
        "VIDEO",
        "INTERSTITIAL",
        "MAP",
        "FEED",
        "STORIES",
        "OTHER"],

      apps: [],

      map: {
        center: {
          latitude: 52.218945,
          longitude: 13.439067
        },
        zoom: 10,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },

      boundaries: [],
    };
  },

  mounted() {
    this.selectedLanguage = this.$locale;
    if (this.placementId != null) {
      this.editMode = true;
      this.fetchEditingPlacement();
    } else {
      // this.fetchApps();
    }
    this.fetchApps();
  },

  methods: {
    _validate(){
      
      if(this.placement.names == null || this.placement.names[this.selectedLanguage] == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("designation") }));
        return false;
      }
      if(this.placement.uniqueName == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("uniqueName") }));
        return false;
      }
      if(this.placement.type == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("type") }));
        return false;
      }
      if(this.placement.cpmPrice == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("cpm_price") }));
        return false;
      }
      if(this.placement.cpcPrice == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("cpc_price") }));
        return false;
      }
      if(this.placement.app == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("app") }));
        return false;
      }
      if(this.placement.previewImage == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("preview_image") }));
        return false;
      }
      if(this.placement.exampleImage == ""){
        this.$noty.error(this.$t("empty_value", { name: this.$t("example_image") }));
        return false;
      }
      console.log(this.placement);
      return true;
    },
    fetchApps(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get(this.routes.apps)
        .then(function (response) {
          _this.apps = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchEditingPlacement() {
      var _this = this;
      this.$axios
        .get("/api/placement/" + this.placementId)
        .then(function (response) {
          _this.placement = response.data;
          _this.placement.names = response.data.namesMap;
        })
        .catch(this.onError);
    },
    // fetchApps(search = ""){
    //   if(search == null) return;
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   this.$axios
    //     .get("/api/app?size=50&search=" + search)
    //     .then(function (response) {
    //       if(_this.tenants.length == 0) _this.tenants = response.data.content;
    //       for (let i = 0; i < response.data.content.length; i++) {
    //         const tenant = response.data.content[i];
    //         if(_this.tenants.filter(t => { return t.name == tenant.name }).length == 0){
    //           _this.tenants.push(tenant);
    //         }
    //       }

    //       if(_this.tenantId != null){
    //         // Remove Tenant which is being edited (no self-adding)
    //         for (let i = _this.tenants.length - 1; i >= 0; i--) {
    //           const tenant = _this.tenants[i];
    //           if(tenant.id == _this.tenantId){
    //             _this.tenants.splice(i, 1);
    //           }
    //         }
    //       }
    //       _this.$forceUpdate();
    //     })
    //     .catch(this.onError)
    //     .finally(this.finalize);
    // },
    save() {
      if(!this._validate()) return;
      var placement = Object.assign({}, this.placement);
      placement.appId = placement.app.id == undefined ? placement.app : placement.app.id;
      delete placement.app;
      if (this.editMode) {
        console.log(placement);
        this.updatePlacement(placement);
      } else {
        this.createPlacement(placement);
      }
    },
    createPlacement(placement) {
      var _this = this;
      this.$axios
        .post("/api/placement", placement)
        .then(function (response) {
          _this.$noty.success(_this.$t("placement_created"));
          _this.$router.push("/placements");
        })
        .catch(this.onError);
    },
    updatePlacement(placement) {
      var _this = this;
      this.$axios
        .put("/api/placement/" + this.placementId, placement)
        .then(function (response) {
          _this.$noty.success(_this.$t("placement_updated"));
          _this.$router.push("/placements");
        })
        .catch(this.onError);
    },
    deletePlacement(){
      var _this = this;
      this.$axios
        .delete("/api/placement/" + this.placementId)
        .then(function (response) {
          _this.showDeleteConfirmation = false;
          _this.$noty.success(_this.$t("placement_deleted"));
          _this.$router.push("/placements");
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(error) {
      console.log(error);
    },
    finalize() {
      progressIndicator.hidden = true;
    }
  },
};
</script>

<style>

</style>